// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as CircleRouteImport } from './routes/circle'
import { Route as ConciergeRouteImport } from './routes/concierge'
import { Route as ForVenuesRouteImport } from './routes/for-venues'
import { Route as MapRouteImport } from './routes/map'
import { Route as MynightRouteImport } from './routes/mynight'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as PulseOpsX7k2RouteImport } from './routes/pulse-ops-x7k2'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as TicketsRouteImport } from './routes/tickets'
import { Route as VendorRouteImport } from './routes/vendor'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as DevEventcardQaRouteImport } from './routes/dev.eventcard-qa'
import { Route as DevSentryTestRouteImport } from './routes/dev.sentry-test'
import { Route as EventIdRouteImport } from './routes/event.$id'
import { Route as FriendsAddRouteImport } from './routes/friends.add'
import { Route as NightRecapMemoryIdRouteImport } from './routes/night-recap.$memoryId'
import { Route as PulseOpsX7k2IndexRouteImport } from './routes/pulse-ops-x7k2.index'
import { Route as PulseOpsX7k2AdminUsersRouteImport } from './routes/pulse-ops-x7k2.admin-users'
import { Route as PulseOpsX7k2DashboardRouteImport } from './routes/pulse-ops-x7k2.dashboard'
import { Route as PulseOpsX7k2DatabaseRouteImport } from './routes/pulse-ops-x7k2.database'
import { Route as PulseOpsX7k2FinancialsRouteImport } from './routes/pulse-ops-x7k2.financials'
import { Route as PulseOpsX7k2HrRouteImport } from './routes/pulse-ops-x7k2.hr'
import { Route as PulseOpsX7k2LogsRouteImport } from './routes/pulse-ops-x7k2.logs'
import { Route as PulseOpsX7k2RecoverRouteImport } from './routes/pulse-ops-x7k2.recover'
import { Route as PulseOpsX7k2RiskFraudRouteImport } from './routes/pulse-ops-x7k2.risk-fraud'
import { Route as PulseOpsX7k2Setup2faRouteImport } from './routes/pulse-ops-x7k2.setup-2fa'
import { Route as PulseOpsX7k2SupportRouteImport } from './routes/pulse-ops-x7k2.support'
import { Route as PulseOpsX7k2TargetCitiesRouteImport } from './routes/pulse-ops-x7k2.target-cities'
import { Route as PulseOpsX7k2TicketsRouteImport } from './routes/pulse-ops-x7k2.tickets'
import { Route as PulseOpsX7k2TransactionsRouteImport } from './routes/pulse-ops-x7k2.transactions'
import { Route as PulseOpsX7k2UsersRouteImport } from './routes/pulse-ops-x7k2.users'
import { Route as PulseOpsX7k2VendorsRouteImport } from './routes/pulse-ops-x7k2.vendors'
import { Route as SquadIdRouteImport } from './routes/squad.$id'
import { Route as UserLoginRouteImport } from './routes/user.login'
import { Route as VendorAboRouteImport } from './routes/vendor.abo'
import { Route as VendorAiAssistantRouteImport } from './routes/vendor.ai-assistant'
import { Route as VendorAmbianceTagsRouteImport } from './routes/vendor.ambiance-tags'
import { Route as VendorCheckInRouteImport } from './routes/vendor.check-in'
import { Route as VendorDashboardRouteImport } from './routes/vendor.dashboard'
import { Route as VendorDemoEinstellungenRouteImport } from './routes/vendor.demo-einstellungen'
import { Route as VendorEinstellungenRouteImport } from './routes/vendor.einstellungen'
import { Route as VendorEventManagerRouteImport } from './routes/vendor.event-manager'
import { Route as VendorLoginRouteImport } from './routes/vendor.login'
import { Route as VendorMarktRadarRouteImport } from './routes/vendor.markt-radar'
import { Route as VendorPendingRouteImport } from './routes/vendor.pending'
import { Route as VendorPromotionRouteImport } from './routes/vendor.promotion'
import { Route as VendorRegisterVenueRouteImport } from './routes/vendor.register-venue'
import { Route as VendorRegistryRouteImport } from './routes/vendor.registry'
import { Route as VendorRegistryUnternehmenRouteImport } from './routes/vendor.registry-unternehmen'
import { Route as VendorTicketingRouteImport } from './routes/vendor.ticketing'
import { Route as VendorVenueDatenRouteImport } from './routes/vendor.venue-daten'
import { Route as VenueIdRouteImport } from './routes/venue.$id'
import { Route as PulseOpsX7k2LogsIndexRouteImport } from './routes/pulse-ops-x7k2.logs.index'
import { Route as PulseOpsX7k2LogsAnomaliesRouteImport } from './routes/pulse-ops-x7k2.logs.anomalies'
import { Route as PulseOpsX7k2LogsCrawlerRouteImport } from './routes/pulse-ops-x7k2.logs.crawler'
import { Route as PulseOpsX7k2RecoverLoginRouteImport } from './routes/pulse-ops-x7k2.recover.login'
import { Route as PulseOpsX7k2SupportIndexRouteImport } from './routes/pulse-ops-x7k2.support.index'
import { Route as PulseOpsX7k2SupportAnalyticsRouteImport } from './routes/pulse-ops-x7k2.support.analytics'
import { Route as PulseOpsX7k2SupportSettingsRouteImport } from './routes/pulse-ops-x7k2.support.settings'
import { Route as PulseOpsX7k2SupportWorkbenchRouteImport } from './routes/pulse-ops-x7k2.support.workbench'
import { Route as PulseOpsX7k2TargetCitiesIndexRouteImport } from './routes/pulse-ops-x7k2.target-cities.index'
import { Route as PulseOpsX7k2TargetCitiesAmbianceTagsRouteImport } from './routes/pulse-ops-x7k2.target-cities.ambiance-tags'
import { Route as PulseOpsX7k2TargetCitiesCandidatesRouteImport } from './routes/pulse-ops-x7k2.target-cities.candidates'
import { Route as PulseOpsX7k2TargetCitiesConfigurationRouteImport } from './routes/pulse-ops-x7k2.target-cities.configuration'
import { Route as PulseOpsX7k2TargetCitiesCrawlerExclusionsRouteImport } from './routes/pulse-ops-x7k2.target-cities.crawler-exclusions'
import { Route as PulseOpsX7k2TargetCitiesEventMetadataRouteImport } from './routes/pulse-ops-x7k2.target-cities.event-metadata'
import { Route as PulseOpsX7k2TargetCitiesPerformanceRouteImport } from './routes/pulse-ops-x7k2.target-cities.performance'
import { Route as PulseOpsX7k2TargetCitiesVenueMetadataRouteImport } from './routes/pulse-ops-x7k2.target-cities.venue-metadata'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const CircleRoute = CircleRouteImport.update({
            id: '/circle',path: '/circle',getParentRoute: () => rootRouteImport
          })
const ConciergeRoute = ConciergeRouteImport.update({
            id: '/concierge',path: '/concierge',getParentRoute: () => rootRouteImport
          })
const ForVenuesRoute = ForVenuesRouteImport.update({
            id: '/for-venues',path: '/for-venues',getParentRoute: () => rootRouteImport
          })
const MapRoute = MapRouteImport.update({
            id: '/map',path: '/map',getParentRoute: () => rootRouteImport
          })
const MynightRoute = MynightRouteImport.update({
            id: '/mynight',path: '/mynight',getParentRoute: () => rootRouteImport
          })
const ProfileRoute = ProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => rootRouteImport
          })
const PulseOpsX7k2Route = PulseOpsX7k2RouteImport.update({
            id: '/pulse-ops-x7k2',path: '/pulse-ops-x7k2',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const SettingsRoute = SettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => rootRouteImport
          })
const TicketsRoute = TicketsRouteImport.update({
            id: '/tickets',path: '/tickets',getParentRoute: () => rootRouteImport
          })
const VendorRoute = VendorRouteImport.update({
            id: '/vendor',path: '/vendor',getParentRoute: () => rootRouteImport
          })
const WelcomeRoute = WelcomeRouteImport.update({
            id: '/welcome',path: '/welcome',getParentRoute: () => rootRouteImport
          })
const DevEventcardQaRoute = DevEventcardQaRouteImport.update({
            id: '/dev/eventcard-qa',path: '/dev/eventcard-qa',getParentRoute: () => rootRouteImport
          })
const DevSentryTestRoute = DevSentryTestRouteImport.update({
            id: '/dev/sentry-test',path: '/dev/sentry-test',getParentRoute: () => rootRouteImport
          })
const EventIdRoute = EventIdRouteImport.update({
            id: '/event/$id',path: '/event/$id',getParentRoute: () => rootRouteImport
          })
const FriendsAddRoute = FriendsAddRouteImport.update({
            id: '/friends/add',path: '/friends/add',getParentRoute: () => rootRouteImport
          })
const NightRecapMemoryIdRoute = NightRecapMemoryIdRouteImport.update({
            id: '/night-recap/$memoryId',path: '/night-recap/$memoryId',getParentRoute: () => rootRouteImport
          })
const PulseOpsX7k2IndexRoute = PulseOpsX7k2IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PulseOpsX7k2Route
          })
const PulseOpsX7k2AdminUsersRoute = PulseOpsX7k2AdminUsersRouteImport.update({
            id: '/admin-users',path: '/admin-users',getParentRoute: () => PulseOpsX7k2Route
          })
const PulseOpsX7k2DashboardRoute = PulseOpsX7k2DashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => PulseOpsX7k2Route
          })
const PulseOpsX7k2DatabaseRoute = PulseOpsX7k2DatabaseRouteImport.update({
            id: '/database',path: '/database',getParentRoute: () => PulseOpsX7k2Route
          })
const PulseOpsX7k2FinancialsRoute = PulseOpsX7k2FinancialsRouteImport.update({
            id: '/financials',path: '/financials',getParentRoute: () => PulseOpsX7k2Route
          })
const PulseOpsX7k2HrRoute = PulseOpsX7k2HrRouteImport.update({
            id: '/hr',path: '/hr',getParentRoute: () => PulseOpsX7k2Route
          })
const PulseOpsX7k2LogsRoute = PulseOpsX7k2LogsRouteImport.update({
            id: '/logs',path: '/logs',getParentRoute: () => PulseOpsX7k2Route
          })
const PulseOpsX7k2RecoverRoute = PulseOpsX7k2RecoverRouteImport.update({
            id: '/recover',path: '/recover',getParentRoute: () => PulseOpsX7k2Route
          })
const PulseOpsX7k2RiskFraudRoute = PulseOpsX7k2RiskFraudRouteImport.update({
            id: '/risk-fraud',path: '/risk-fraud',getParentRoute: () => PulseOpsX7k2Route
          })
const PulseOpsX7k2Setup2faRoute = PulseOpsX7k2Setup2faRouteImport.update({
            id: '/setup-2fa',path: '/setup-2fa',getParentRoute: () => PulseOpsX7k2Route
          })
const PulseOpsX7k2SupportRoute = PulseOpsX7k2SupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => PulseOpsX7k2Route
          })
const PulseOpsX7k2TargetCitiesRoute = PulseOpsX7k2TargetCitiesRouteImport.update({
            id: '/target-cities',path: '/target-cities',getParentRoute: () => PulseOpsX7k2Route
          })
const PulseOpsX7k2TicketsRoute = PulseOpsX7k2TicketsRouteImport.update({
            id: '/tickets',path: '/tickets',getParentRoute: () => PulseOpsX7k2Route
          })
const PulseOpsX7k2TransactionsRoute = PulseOpsX7k2TransactionsRouteImport.update({
            id: '/transactions',path: '/transactions',getParentRoute: () => PulseOpsX7k2Route
          })
const PulseOpsX7k2UsersRoute = PulseOpsX7k2UsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => PulseOpsX7k2Route
          })
const PulseOpsX7k2VendorsRoute = PulseOpsX7k2VendorsRouteImport.update({
            id: '/vendors',path: '/vendors',getParentRoute: () => PulseOpsX7k2Route
          })
const SquadIdRoute = SquadIdRouteImport.update({
            id: '/squad/$id',path: '/squad/$id',getParentRoute: () => rootRouteImport
          })
const UserLoginRoute = UserLoginRouteImport.update({
            id: '/user/login',path: '/user/login',getParentRoute: () => rootRouteImport
          })
const VendorAboRoute = VendorAboRouteImport.update({
            id: '/abo',path: '/abo',getParentRoute: () => VendorRoute
          })
const VendorAiAssistantRoute = VendorAiAssistantRouteImport.update({
            id: '/ai-assistant',path: '/ai-assistant',getParentRoute: () => VendorRoute
          })
const VendorAmbianceTagsRoute = VendorAmbianceTagsRouteImport.update({
            id: '/ambiance-tags',path: '/ambiance-tags',getParentRoute: () => VendorRoute
          })
const VendorCheckInRoute = VendorCheckInRouteImport.update({
            id: '/check-in',path: '/check-in',getParentRoute: () => VendorRoute
          })
const VendorDashboardRoute = VendorDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => VendorRoute
          })
const VendorDemoEinstellungenRoute = VendorDemoEinstellungenRouteImport.update({
            id: '/demo-einstellungen',path: '/demo-einstellungen',getParentRoute: () => VendorRoute
          })
const VendorEinstellungenRoute = VendorEinstellungenRouteImport.update({
            id: '/einstellungen',path: '/einstellungen',getParentRoute: () => VendorRoute
          })
const VendorEventManagerRoute = VendorEventManagerRouteImport.update({
            id: '/event-manager',path: '/event-manager',getParentRoute: () => VendorRoute
          })
const VendorLoginRoute = VendorLoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => VendorRoute
          })
const VendorMarktRadarRoute = VendorMarktRadarRouteImport.update({
            id: '/markt-radar',path: '/markt-radar',getParentRoute: () => VendorRoute
          })
const VendorPendingRoute = VendorPendingRouteImport.update({
            id: '/pending',path: '/pending',getParentRoute: () => VendorRoute
          })
const VendorPromotionRoute = VendorPromotionRouteImport.update({
            id: '/promotion',path: '/promotion',getParentRoute: () => VendorRoute
          })
const VendorRegisterVenueRoute = VendorRegisterVenueRouteImport.update({
            id: '/register-venue',path: '/register-venue',getParentRoute: () => VendorRoute
          })
const VendorRegistryRoute = VendorRegistryRouteImport.update({
            id: '/registry',path: '/registry',getParentRoute: () => VendorRoute
          })
const VendorRegistryUnternehmenRoute = VendorRegistryUnternehmenRouteImport.update({
            id: '/registry-unternehmen',path: '/registry-unternehmen',getParentRoute: () => VendorRoute
          })
const VendorTicketingRoute = VendorTicketingRouteImport.update({
            id: '/ticketing',path: '/ticketing',getParentRoute: () => VendorRoute
          })
const VendorVenueDatenRoute = VendorVenueDatenRouteImport.update({
            id: '/venue-daten',path: '/venue-daten',getParentRoute: () => VendorRoute
          })
const VenueIdRoute = VenueIdRouteImport.update({
            id: '/venue/$id',path: '/venue/$id',getParentRoute: () => rootRouteImport
          })
const PulseOpsX7k2LogsIndexRoute = PulseOpsX7k2LogsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PulseOpsX7k2LogsRoute
          })
const PulseOpsX7k2LogsAnomaliesRoute = PulseOpsX7k2LogsAnomaliesRouteImport.update({
            id: '/anomalies',path: '/anomalies',getParentRoute: () => PulseOpsX7k2LogsRoute
          })
const PulseOpsX7k2LogsCrawlerRoute = PulseOpsX7k2LogsCrawlerRouteImport.update({
            id: '/crawler',path: '/crawler',getParentRoute: () => PulseOpsX7k2LogsRoute
          })
const PulseOpsX7k2RecoverLoginRoute = PulseOpsX7k2RecoverLoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => PulseOpsX7k2RecoverRoute
          })
const PulseOpsX7k2SupportIndexRoute = PulseOpsX7k2SupportIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PulseOpsX7k2SupportRoute
          })
const PulseOpsX7k2SupportAnalyticsRoute = PulseOpsX7k2SupportAnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => PulseOpsX7k2SupportRoute
          })
const PulseOpsX7k2SupportSettingsRoute = PulseOpsX7k2SupportSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => PulseOpsX7k2SupportRoute
          })
const PulseOpsX7k2SupportWorkbenchRoute = PulseOpsX7k2SupportWorkbenchRouteImport.update({
            id: '/workbench',path: '/workbench',getParentRoute: () => PulseOpsX7k2SupportRoute
          })
const PulseOpsX7k2TargetCitiesIndexRoute = PulseOpsX7k2TargetCitiesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PulseOpsX7k2TargetCitiesRoute
          })
const PulseOpsX7k2TargetCitiesAmbianceTagsRoute = PulseOpsX7k2TargetCitiesAmbianceTagsRouteImport.update({
            id: '/ambiance-tags',path: '/ambiance-tags',getParentRoute: () => PulseOpsX7k2TargetCitiesRoute
          })
const PulseOpsX7k2TargetCitiesCandidatesRoute = PulseOpsX7k2TargetCitiesCandidatesRouteImport.update({
            id: '/candidates',path: '/candidates',getParentRoute: () => PulseOpsX7k2TargetCitiesRoute
          })
const PulseOpsX7k2TargetCitiesConfigurationRoute = PulseOpsX7k2TargetCitiesConfigurationRouteImport.update({
            id: '/configuration',path: '/configuration',getParentRoute: () => PulseOpsX7k2TargetCitiesRoute
          })
const PulseOpsX7k2TargetCitiesCrawlerExclusionsRoute = PulseOpsX7k2TargetCitiesCrawlerExclusionsRouteImport.update({
            id: '/crawler-exclusions',path: '/crawler-exclusions',getParentRoute: () => PulseOpsX7k2TargetCitiesRoute
          })
const PulseOpsX7k2TargetCitiesEventMetadataRoute = PulseOpsX7k2TargetCitiesEventMetadataRouteImport.update({
            id: '/event-metadata',path: '/event-metadata',getParentRoute: () => PulseOpsX7k2TargetCitiesRoute
          })
const PulseOpsX7k2TargetCitiesPerformanceRoute = PulseOpsX7k2TargetCitiesPerformanceRouteImport.update({
            id: '/performance',path: '/performance',getParentRoute: () => PulseOpsX7k2TargetCitiesRoute
          })
const PulseOpsX7k2TargetCitiesVenueMetadataRoute = PulseOpsX7k2TargetCitiesVenueMetadataRouteImport.update({
            id: '/venue-metadata',path: '/venue-metadata',getParentRoute: () => PulseOpsX7k2TargetCitiesRoute
          })





const PulseOpsX7k2LogsRouteChildren = {
  PulseOpsX7k2LogsAnomaliesRoute: PulseOpsX7k2LogsAnomaliesRoute,PulseOpsX7k2LogsCrawlerRoute: PulseOpsX7k2LogsCrawlerRoute,PulseOpsX7k2LogsIndexRoute: PulseOpsX7k2LogsIndexRoute
}

const PulseOpsX7k2LogsRouteWithChildren = PulseOpsX7k2LogsRoute._addFileChildren(PulseOpsX7k2LogsRouteChildren)




const PulseOpsX7k2RecoverRouteChildren = {
  PulseOpsX7k2RecoverLoginRoute: PulseOpsX7k2RecoverLoginRoute
}

const PulseOpsX7k2RecoverRouteWithChildren = PulseOpsX7k2RecoverRoute._addFileChildren(PulseOpsX7k2RecoverRouteChildren)




const PulseOpsX7k2SupportRouteChildren = {
  PulseOpsX7k2SupportAnalyticsRoute: PulseOpsX7k2SupportAnalyticsRoute,PulseOpsX7k2SupportSettingsRoute: PulseOpsX7k2SupportSettingsRoute,PulseOpsX7k2SupportWorkbenchRoute: PulseOpsX7k2SupportWorkbenchRoute,PulseOpsX7k2SupportIndexRoute: PulseOpsX7k2SupportIndexRoute
}

const PulseOpsX7k2SupportRouteWithChildren = PulseOpsX7k2SupportRoute._addFileChildren(PulseOpsX7k2SupportRouteChildren)




const PulseOpsX7k2TargetCitiesRouteChildren = {
  PulseOpsX7k2TargetCitiesAmbianceTagsRoute: PulseOpsX7k2TargetCitiesAmbianceTagsRoute,PulseOpsX7k2TargetCitiesCandidatesRoute: PulseOpsX7k2TargetCitiesCandidatesRoute,PulseOpsX7k2TargetCitiesConfigurationRoute: PulseOpsX7k2TargetCitiesConfigurationRoute,PulseOpsX7k2TargetCitiesCrawlerExclusionsRoute: PulseOpsX7k2TargetCitiesCrawlerExclusionsRoute,PulseOpsX7k2TargetCitiesEventMetadataRoute: PulseOpsX7k2TargetCitiesEventMetadataRoute,PulseOpsX7k2TargetCitiesPerformanceRoute: PulseOpsX7k2TargetCitiesPerformanceRoute,PulseOpsX7k2TargetCitiesVenueMetadataRoute: PulseOpsX7k2TargetCitiesVenueMetadataRoute,PulseOpsX7k2TargetCitiesIndexRoute: PulseOpsX7k2TargetCitiesIndexRoute
}

const PulseOpsX7k2TargetCitiesRouteWithChildren = PulseOpsX7k2TargetCitiesRoute._addFileChildren(PulseOpsX7k2TargetCitiesRouteChildren)



const PulseOpsX7k2RouteChildren = {
  PulseOpsX7k2AdminUsersRoute: PulseOpsX7k2AdminUsersRoute,PulseOpsX7k2DashboardRoute: PulseOpsX7k2DashboardRoute,PulseOpsX7k2DatabaseRoute: PulseOpsX7k2DatabaseRoute,PulseOpsX7k2FinancialsRoute: PulseOpsX7k2FinancialsRoute,PulseOpsX7k2HrRoute: PulseOpsX7k2HrRoute,PulseOpsX7k2LogsRoute: PulseOpsX7k2LogsRouteWithChildren,PulseOpsX7k2RecoverRoute: PulseOpsX7k2RecoverRouteWithChildren,PulseOpsX7k2RiskFraudRoute: PulseOpsX7k2RiskFraudRoute,PulseOpsX7k2Setup2faRoute: PulseOpsX7k2Setup2faRoute,PulseOpsX7k2SupportRoute: PulseOpsX7k2SupportRouteWithChildren,PulseOpsX7k2TargetCitiesRoute: PulseOpsX7k2TargetCitiesRouteWithChildren,PulseOpsX7k2TicketsRoute: PulseOpsX7k2TicketsRoute,PulseOpsX7k2TransactionsRoute: PulseOpsX7k2TransactionsRoute,PulseOpsX7k2UsersRoute: PulseOpsX7k2UsersRoute,PulseOpsX7k2VendorsRoute: PulseOpsX7k2VendorsRoute,PulseOpsX7k2IndexRoute: PulseOpsX7k2IndexRoute
}

const PulseOpsX7k2RouteWithChildren = PulseOpsX7k2Route._addFileChildren(PulseOpsX7k2RouteChildren)




const VendorRouteChildren = {
  VendorAboRoute: VendorAboRoute,VendorAiAssistantRoute: VendorAiAssistantRoute,VendorAmbianceTagsRoute: VendorAmbianceTagsRoute,VendorCheckInRoute: VendorCheckInRoute,VendorDashboardRoute: VendorDashboardRoute,VendorDemoEinstellungenRoute: VendorDemoEinstellungenRoute,VendorEinstellungenRoute: VendorEinstellungenRoute,VendorEventManagerRoute: VendorEventManagerRoute,VendorLoginRoute: VendorLoginRoute,VendorMarktRadarRoute: VendorMarktRadarRoute,VendorPendingRoute: VendorPendingRoute,VendorPromotionRoute: VendorPromotionRoute,VendorRegisterVenueRoute: VendorRegisterVenueRoute,VendorRegistryRoute: VendorRegistryRoute,VendorRegistryUnternehmenRoute: VendorRegistryUnternehmenRoute,VendorTicketingRoute: VendorTicketingRoute,VendorVenueDatenRoute: VendorVenueDatenRoute
}

const VendorRouteWithChildren = VendorRoute._addFileChildren(VendorRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,CircleRoute: CircleRoute,ConciergeRoute: ConciergeRoute,ForVenuesRoute: ForVenuesRoute,MapRoute: MapRoute,MynightRoute: MynightRoute,ProfileRoute: ProfileRoute,PulseOpsX7k2Route: PulseOpsX7k2RouteWithChildren,ResetPasswordRoute: ResetPasswordRoute,SettingsRoute: SettingsRoute,TicketsRoute: TicketsRoute,VendorRoute: VendorRouteWithChildren,WelcomeRoute: WelcomeRoute,DevEventcardQaRoute: DevEventcardQaRoute,DevSentryTestRoute: DevSentryTestRoute,EventIdRoute: EventIdRoute,FriendsAddRoute: FriendsAddRoute,NightRecapMemoryIdRoute: NightRecapMemoryIdRoute,SquadIdRoute: SquadIdRoute,UserLoginRoute: UserLoginRoute,VenueIdRoute: VenueIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)